import { render, staticRenderFns } from "./CustomerBlock.vue?vue&type=template&id=ff52952e&scoped=true&lang=pug&"
import script from "./CustomerBlock.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomerBlock.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CustomerBlock.vue?vue&type=style&index=0&id=ff52952e&prod&lang=scss&scoped=true&"
import style1 from "./CustomerBlock.vue?vue&type=style&index=1&id=ff52952e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff52952e",
  null
  
)

export default component.exports